var _path, _path2, _path3, _mask, _path4, _path5, _path6, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplicationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 323,
    height: 259,
    viewBox: "0 0 323 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M284.6 74.6875V74.1875H284.1H276.287H275.787V74.6875V76.5625V77.0625H276.287H284.1H284.6V76.5625V74.6875Z",
    fill: "#018BFF",
    stroke: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M274.912 62.5V62H274.412H257.225H256.725V62.5V64.6875V65.1875H257.225H264.225V83.75V84.25H264.725H266.912H267.412V83.75V65.1875H274.412H274.912V64.6875V62.5Z",
    fill: "#018BFF",
    stroke: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M293.975 62.5V62H293.475H286.287H285.787V62.5V64.6875V65.1875H286.287H290.787V83.75V84.25H291.287H293.475H293.975V83.75V62.5Z",
    fill: "#018BFF",
    stroke: "#D9D9D9"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-1_565_10471",
    maskUnits: "userSpaceOnUse",
    x: 211.125,
    y: 61.8115,
    width: 23,
    height: 24,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 211.125,
    y: 61.8115,
    width: 23,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.225 62.8115C212 62.8115 212.225 62.8115 212.225 62.8115V62.8115C212.649 62.8115 214.677 62.8115 222.85 62.8115C235.35 62.8115 235.201 84.0615 222.85 84.0615C210.498 84.0615 212.225 84.0615 212.225 84.0615V73.4365H214.725V81.874H222.85C232.225 81.874 232.85 64.9996 222.85 64.9996H212.225V62.8115Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M212.225 62.8115C212 62.8115 212.225 62.8115 212.225 62.8115V62.8115C212.649 62.8115 214.677 62.8115 222.85 62.8115C235.35 62.8115 235.201 84.0615 222.85 84.0615C210.498 84.0615 212.225 84.0615 212.225 84.0615V73.4365H214.725V81.874H222.85C232.225 81.874 232.85 64.9996 222.85 64.9996H212.225V62.8115Z",
    fill: "#018BFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M212.225 62.8115H213.225V61.8115L212.225 61.8115L212.225 62.8115ZM222.85 62.8115L222.85 61.8115L222.85 62.8115ZM222.85 84.0615L222.85 85.0615L222.85 84.0615ZM212.225 84.0615L212.225 85.0615L213.225 85.0615V84.0615H212.225ZM212.225 73.4365V72.4365H211.225V73.4365H212.225ZM214.725 73.4365H215.725V72.4365H214.725V73.4365ZM214.725 81.874H213.725V82.874H214.725V81.874ZM212.225 64.9996H211.225V65.9996H212.225V64.9996ZM212.225 62.8115C212.225 61.8115 212.225 61.8115 212.225 61.8115C212.225 61.8115 212.225 61.8115 212.225 61.8115C212.225 61.8115 212.225 61.8115 212.225 61.8115C212.225 61.8115 212.225 61.8115 212.225 61.8115C212.225 61.8115 212.224 61.8115 212.224 61.8115C212.224 61.8115 212.223 61.8115 212.222 61.8115C212.221 61.8115 212.219 61.8115 212.216 61.8115C212.21 61.8115 212.202 61.8115 212.193 61.8115C212.176 61.8115 212.155 61.8115 212.141 61.8115C212.134 61.8115 212.128 61.8115 212.126 61.8115C212.126 61.8115 212.125 61.8115 212.125 61.8115C212.125 61.8115 212.124 61.8115 212.124 61.8115C212.124 61.8115 212.124 61.8115 212.124 61.8115C212.124 61.8115 212.123 61.8115 212.123 61.8115C212.123 61.8115 212.12 61.8115 212.118 61.8116C211.125 62.8079 212.116 63.8115 212.121 63.8115C212.122 63.8115 212.123 63.8115 212.124 63.8115C212.124 63.8115 212.124 63.8115 212.124 63.8115C212.125 63.8115 212.125 63.8115 212.125 63.8115C212.126 63.8115 212.127 63.8115 212.13 63.8115C212.141 63.8115 212.169 63.8115 212.225 63.8115L212.225 61.8115C212.169 61.8115 212.141 61.8115 212.13 61.8115C212.127 61.8115 212.126 61.8115 212.126 61.8115C212.125 61.8115 212.126 61.8115 212.126 61.8115C212.126 61.8115 212.126 61.8115 212.126 61.8115C212.127 61.8115 212.128 61.8115 212.129 61.8115C212.134 61.8116 213.125 62.8152 212.132 63.8115C212.13 63.8115 212.127 63.8115 212.127 63.8115C212.127 63.8115 212.126 63.8115 212.126 63.8115C212.126 63.8115 212.126 63.8115 212.126 63.8115C212.126 63.8115 212.126 63.8115 212.126 63.8115C212.125 63.8115 212.126 63.8115 212.126 63.8115C212.128 63.8115 212.134 63.8115 212.141 63.8115C212.155 63.8115 212.176 63.8115 212.193 63.8115C212.202 63.8115 212.21 63.8115 212.216 63.8115C212.219 63.8115 212.221 63.8115 212.222 63.8115C212.223 63.8115 212.224 63.8115 212.224 63.8115C212.224 63.8115 212.225 63.8115 212.225 63.8115C212.225 63.8115 212.225 63.8115 212.225 63.8115C212.225 63.8115 212.225 63.8115 212.225 63.8115C212.225 63.8115 212.225 63.8115 212.225 63.8115C212.225 63.8115 212.225 63.8115 212.225 62.8115ZM212.225 63.8115C212.649 63.8115 214.677 63.8115 222.85 63.8115L222.85 61.8115C214.677 61.8115 212.649 61.8115 212.225 61.8115L212.225 63.8115ZM222.85 63.8115C225.656 63.8115 227.703 64.9891 229.071 66.7461C230.46 68.5304 231.178 70.9572 231.169 73.433C231.161 75.9087 230.426 78.3384 229.03 80.1258C227.655 81.8869 225.615 83.0615 222.85 83.0615L222.85 85.0615C226.26 85.0615 228.871 83.5799 230.607 81.3566C232.322 79.1596 233.159 76.2768 233.169 73.44C233.179 70.6033 232.362 67.7176 230.649 65.5175C228.915 63.2901 226.294 61.8115 222.85 61.8115L222.85 63.8115ZM222.85 83.0615C216.674 83.0615 214.018 83.0615 212.906 83.0615C212.349 83.0615 212.179 83.0615 212.148 83.0615C212.142 83.0615 212.143 83.0615 212.145 83.0615C213.142 84.0624 212.143 85.0615 212.143 85.0615C212.143 85.0615 212.143 85.0615 212.143 85.0615C212.143 85.0615 212.143 85.0615 212.143 85.0615C212.143 85.0615 212.143 85.0615 212.144 85.0615C212.144 85.0615 212.146 85.0615 212.147 85.0615C212.153 85.0615 212.163 85.0615 212.175 85.0615C212.186 85.0615 212.199 85.0615 212.209 85.0615C212.213 85.0615 212.217 85.0615 212.22 85.0615C212.222 85.0615 212.223 85.0615 212.224 85.0615C212.224 85.0615 212.224 85.0615 212.225 85.0615C212.225 85.0615 212.225 85.0615 212.225 85.0615C212.225 85.0615 212.225 85.0615 212.225 85.0615C212.225 85.0615 212.225 85.0615 212.225 84.0615C212.225 83.0615 212.225 83.0615 212.225 83.0615C212.225 83.0615 212.225 83.0615 212.225 83.0615C212.225 83.0615 212.225 83.0615 212.225 83.0615C212.224 83.0615 212.224 83.0615 212.224 83.0615C212.223 83.0615 212.222 83.0615 212.22 83.0615C212.217 83.0615 212.213 83.0615 212.208 83.0615C212.199 83.0615 212.186 83.0615 212.175 83.0615C212.163 83.0615 212.153 83.0615 212.147 83.0615C212.146 83.0615 212.144 83.0615 212.144 83.0615C212.143 83.0615 212.143 83.0615 212.143 83.0615C212.143 83.0615 212.142 83.0615 212.142 83.0615C212.142 83.0615 212.142 83.0615 212.142 83.0615C212.142 83.0615 211.142 84.0606 212.14 85.0615C212.142 85.0615 212.146 85.0615 212.148 85.0615C212.179 85.0615 212.349 85.0615 212.906 85.0615C214.018 85.0615 216.674 85.0615 222.85 85.0615L222.85 83.0615ZM213.225 84.0615V73.4365H211.225V84.0615H213.225ZM212.225 74.4365H214.725V72.4365H212.225V74.4365ZM213.725 73.4365V81.874H215.725V73.4365H213.725ZM214.725 82.874H222.85V80.874H214.725V82.874ZM222.85 82.874C225.532 82.874 227.611 81.6525 229.003 79.8483C230.376 78.0684 231.073 75.7412 231.115 73.4553C231.158 71.1702 230.548 68.8279 229.184 67.0315C227.796 65.2047 225.668 63.9996 222.85 63.9996V65.9996C225.032 65.9996 226.575 66.9039 227.591 68.241C228.629 69.6086 229.152 71.4848 229.116 73.4183C229.08 75.3511 228.488 77.2424 227.42 78.6265C226.37 79.9862 224.856 80.874 222.85 80.874V82.874ZM222.85 63.9996H212.225V65.9996H222.85V63.9996ZM213.225 64.9996V62.8115H211.225V64.9996H213.225ZM213.225 62.8115V62.8115H211.225V62.8115H213.225Z",
    fill: "#D9D9D9",
    mask: "url(#path-4-outside-1_565_10471)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M237.225 62.8117L237.225 62.3117L236.725 62.3118V62.8117V64.6871V65.1871H237.225H247.85C249.139 65.1871 250.014 65.6132 250.56 66.1996C251.111 66.7923 251.369 67.594 251.334 68.4163C251.266 70.0632 250.044 71.6871 247.85 71.6871H237.225H236.725V72.1871V73.1246V74.3746V74.8746H237.225H247.85C249.558 74.8746 250.741 75.3382 251.478 75.974C252.213 76.6071 252.539 77.4369 252.506 78.2609C252.441 79.8877 250.925 81.6871 247.85 81.6871H237.225H236.725V82.1871V84.0621V84.5621H237.225H247.85C250.365 84.5621 252.286 83.8511 253.582 82.7314C254.878 81.6108 255.52 80.1033 255.498 78.5862C255.464 76.2324 253.863 73.9839 250.913 73.0624C251.637 72.7646 252.256 72.3596 252.765 71.8751C253.883 70.8104 254.443 69.3888 254.443 67.9681C254.443 66.5475 253.883 65.1258 252.765 64.0611C251.643 62.9934 249.99 62.3118 247.85 62.3117C243.787 62.3115 241.131 62.3115 239.49 62.3116L237.742 62.3117L237.348 62.3117L237.255 62.3117L237.232 62.3117L237.226 62.3117L237.225 62.3117L237.225 62.3117L237.225 62.3117L237.225 62.8117Z",
    fill: "#018BFF",
    stroke: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_565_10471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.936 175.152V167.436H64.9542L56.4666 157.405L54.9234 162.035L50.2938 162.806L61.0962 175.152H108.936Z",
    fill: "#018BFF",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.066 145.833H125.912V154.321H157.548L125.141 189.043H71.9001V196.759H128.999L176.066 145.833Z",
    fill: "#018BFF",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.084 123.453H145.207V124.225V131.941H108.942L92.7381 148.144L86.5653 142.743L105.084 123.453Z",
    fill: "#018BFF",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.41 129.63H277.929V137.346H263.268L243.207 156.636H198.454L179.935 137.346L185.336 131.173L202.312 148.92H240.12L259.41 129.63Z",
    fill: "#018BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.219 168.21H227.775V176.698H176.077L105.861 250V219.136H114.349V229.167L172.219 168.21Z",
    fill: "#018BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.41 129.63H277.929V137.346H263.268L243.207 156.636H198.454L179.935 137.346L185.336 131.173L202.312 148.92H240.12L259.41 129.63Z",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.219 168.21H227.775V176.698H176.077L105.861 250V219.136H114.349V229.167L172.219 168.21Z",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5817 59.4126H102.767L101.223 55.5546L102.767 50.925H61.8717L69.5877 42.4373L63.4149 37.0361L42.5817 59.4126Z",
    fill: "#018BFF",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4031 70.9897H108.162L68.8104 113.428L67.2672 109.567L62.6376 107.255L89.6437 78.7058H88.8721H39.4895L34.8599 84.8786H64.9524L39.4895 111.885L37.9463 108.024L33.3167 106.483L45.6623 93.3662H17.1131L36.4031 70.9897Z",
    fill: "#018BFF",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.082 114.967H294.891L295.662 106.479L254.767 106.479L252.452 107.25L233.934 124.997H207.699C201.527 118.825 189.181 106.325 189.181 105.708C189.181 105.09 126.424 105.45 95.0456 105.708V106.479L70.3544 131.942H20.9718L22.515 135.8L20.9718 140.43H74.2124L98.6235 114.195L186.095 114.195L204.613 133.485H235.477L238.564 132.714L257.082 114.967Z",
    fill: "#018BFF",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.419 70.9854V82.5594H304.931V71.757L284.098 43.9793L219.284 43.9793L189.191 74.8434L220.827 108.794L227 102.621L232.401 108.794L220.055 121.14L177.617 74.8434L215.425 35.4917L288.728 35.4917L312.647 68.6706L313.419 70.9854Z",
    fill: "#018BFF",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.152 12.3413L184.554 17.7425L118.196 88.7299H165.264V97.2175H98.9059L179.152 12.3413Z",
    fill: "#018BFF",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.176 72.8242C146.176 77.8274 150.232 81.8834 155.235 81.8834C160.238 81.8834 164.294 77.8274 164.294 72.8242C164.294 67.8209 160.238 63.7649 155.235 63.7649C150.232 63.7649 146.176 67.8209 146.176 72.8242Z",
    fill: "#018BFF",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.58 9.25922C178.58 14.2625 182.636 18.3184 187.639 18.3184C192.642 18.3184 196.698 14.2625 196.698 9.25922C196.698 4.25595 192.642 0.2 187.639 0.2C182.636 0.2 178.58 4.25595 178.58 9.25922Z",
    fill: "#018BFF",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.688 92.5922C164.688 97.5955 168.744 101.651 173.748 101.651C178.751 101.651 182.807 97.5955 182.807 92.5922C182.807 87.589 178.751 83.533 173.748 83.533C168.744 83.533 164.688 87.589 164.688 92.5922Z",
    fill: "#018BFF",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.19913 135.805C4.19913 140.808 8.25508 144.864 13.2584 144.864C18.2616 144.864 22.3176 140.808 22.3176 135.805C22.3176 130.802 18.2616 126.746 13.2584 126.746C8.25508 126.746 4.19913 130.802 4.19913 135.805Z",
    fill: "#018BFF",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7226 114.491C22.7226 119.494 26.7785 123.55 31.7818 123.55C36.7851 123.55 40.841 119.494 40.841 114.491C40.841 109.487 36.7851 105.431 31.7818 105.431C26.7785 105.431 22.7226 109.487 22.7226 114.491Z",
    fill: "#018BFF",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.425 55.5541C101.425 60.5574 105.481 64.6134 110.484 64.6134C115.487 64.6134 119.543 60.5574 119.543 55.5541C119.543 50.5509 115.487 46.4949 110.484 46.4949C105.481 46.4949 101.425 50.5509 101.425 55.5541Z",
    fill: "#018BFF",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.425 211.415C101.425 216.418 105.481 220.474 110.484 220.474C115.487 220.474 119.543 216.418 119.543 211.415C119.543 206.412 115.487 202.356 110.484 202.356C105.481 202.356 101.425 206.412 101.425 211.415Z",
    fill: "#018BFF",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.25922,
    cy: 9.25922,
    r: 9.05922,
    transform: "matrix(-1 0 0 1 125.92 162.035)",
    fill: "#018BFF",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1269 192.897C55.1269 197.9 59.1828 201.956 64.1861 201.956C69.1894 201.956 73.2453 197.9 73.2453 192.897C73.2453 187.894 69.1894 183.838 64.1861 183.838C59.1828 183.838 55.1269 187.894 55.1269 192.897Z",
    fill: "#018BFF",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6903 155.573C39.6903 160.576 43.7463 164.632 48.7496 164.632C53.7528 164.632 57.8088 160.576 57.8088 155.573C57.8088 150.569 53.7528 146.513 48.7496 146.513C43.7463 146.513 39.6903 150.569 39.6903 155.573Z",
    fill: "#018BFF",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.748 114.491C51.748 119.494 55.8039 123.55 60.8072 123.55C65.8105 123.55 69.8664 119.494 69.8664 114.491C69.8664 109.487 65.8105 105.431 60.8072 105.431C55.8039 105.431 51.748 109.487 51.748 114.491Z",
    fill: "#018BFF",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1874 151.23C75.1874 156.234 79.2434 160.29 84.2466 160.29C89.2499 160.29 93.3059 156.234 93.3059 151.23C93.3059 146.227 89.2499 142.171 84.2466 142.171C79.2434 142.171 75.1874 146.227 75.1874 151.23Z",
    fill: "#018BFF",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.25923,
    cy: 9.25923,
    r: 9.05923,
    transform: "matrix(-1 0 0 1 127.449 140.425)",
    fill: "#018BFF",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.25922,
    cy: 9.25922,
    r: 9.05922,
    transform: "matrix(-1 0 0 1 244.742 163.582)",
    fill: "#018BFF",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.806 134.259C275.806 139.262 279.862 143.318 284.865 143.318C289.868 143.318 293.924 139.262 293.924 134.259C293.924 129.255 289.868 125.2 284.865 125.2C279.862 125.2 275.806 129.255 275.806 134.259Z",
    fill: "#018BFF",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.091 128.082C143.091 133.085 147.147 137.141 152.15 137.141C157.153 137.141 161.209 133.085 161.209 128.082C161.209 123.079 157.153 119.023 152.15 119.023C147.147 119.023 143.091 123.079 143.091 128.082Z",
    fill: "#018BFF",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.782 129.332C167.782 134.335 171.838 138.391 176.841 138.391C181.845 138.391 185.901 134.335 185.901 129.332C185.901 124.329 181.845 120.273 176.841 120.273C171.838 120.273 167.782 124.329 167.782 129.332Z",
    fill: "#018BFF",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8339 33.954C62.8339 38.9573 66.8898 43.0133 71.8931 43.0133C76.8964 43.0133 80.9523 38.9573 80.9523 33.954C80.9523 28.9508 76.8964 24.8948 71.8931 24.8948C66.8898 24.8948 62.8339 28.9508 62.8339 33.954Z",
    fill: "#018BFF",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.696 22.8505C243.696 27.8538 247.752 31.9098 252.755 31.9098C257.759 31.9098 261.815 27.8538 261.815 22.8505C261.815 17.8473 257.759 13.7913 252.755 13.7913C247.752 13.7913 243.696 17.8473 243.696 22.8505Z",
    fill: "#018BFF",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.25922,
    cy: 9.25922,
    r: 9.05922,
    transform: "matrix(-1 0 0 1 244.742 91.0459)",
    fill: "#018BFF",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.319 111.11C294.319 116.114 298.375 120.17 303.378 120.17C308.382 120.17 312.438 116.114 312.438 111.11C312.438 106.107 308.382 102.051 303.378 102.051C298.375 102.051 294.319 106.107 294.319 111.11Z",
    fill: "#018BFF",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.824 3.08203L167.577 3.08505L139.028 31.6313L138.256 29.3165L136.713 27.7733L135.17 27.0017L132.855 26.2301L146.744 10.7981L125.911 10.7981L105.077 32.4029L104.306 30.0881L102.763 28.5449L101.219 27.0017L99.6762 26.2301L122.824 3.08203Z",
    fill: "#018BFF",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.734 34.2421C122.734 39.2454 126.79 43.3014 131.794 43.3014C136.797 43.3014 140.853 39.2454 140.853 34.2421C140.853 29.2389 136.797 25.1829 131.794 25.1829C126.79 25.1829 122.734 29.2389 122.734 34.2421Z",
    fill: "#018BFF",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5331 33.9501C87.5331 38.9534 91.5891 43.0094 96.5923 43.0094C101.596 43.0094 105.652 38.9534 105.652 33.9501C105.652 28.9469 101.596 24.8909 96.5923 24.8909C91.5891 24.8909 87.5331 28.9469 87.5331 33.9501Z",
    fill: "#018BFF",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.155 26.2341H245.507L244.735 23.9193V22.3761V20.8329L245.507 18.5181L201.526 18.5181L157.544 64.8142L159.859 65.5858L161.402 67.129L162.945 68.6722L163.717 70.2154L206.155 26.2341Z",
    fill: "#018BFF",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.496 89.7958C300.496 94.7991 304.552 98.8551 309.555 98.8551C314.559 98.8551 318.614 94.7991 318.614 89.7958C318.614 84.7926 314.559 80.7366 309.555 80.7366C304.552 80.7366 300.496 84.7926 300.496 89.7958Z",
    fill: "#018BFF",
    stroke: "#D9D9D9",
    strokeWidth: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_565_10471",
    x: -0.000976562,
    y: 0,
    width: 322.815,
    height: 258.498,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00392157 0 0 0 0 0.545098 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_565_10471"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_565_10471",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationIcon);
export default __webpack_public_path__ + "static/media/ApplicationIcon.eba367a42a9b7410bdba3c7d24b3a29f.svg";
export { ForwardRef as ReactComponent };